import React from 'react';
import { EAddress } from 'lib/types';
import { State } from 'lib/enums';

export type BillToInfo = {
  billToName: string;
  billToEmail: string;
  billingAddress: EAddress | null;
};

type InvoiceFormCustomerTableProps = {
  billTo: BillToInfo | null;
};

function AddressLines({ address }: { address: EAddress }) {
  return (
    <span>
      {address.address_line1} <br />
      {address.address_line2 && (
        <>
          {address.address_line2} <br />
        </>
      )}
      {address.address_city}{' '}
      {State.by_value(address.address_state)?.abbrev.toUpperCase()},{' '}
      {address.address_zip}
    </span>
  );
}

export default function InvoiceFormCustomerTable({
  billTo
}: InvoiceFormCustomerTableProps) {
  const billToName = billTo?.billToName ?? null;
  const billToEmail = billTo?.billToEmail ?? null;
  const billingAddress = billTo?.billingAddress ?? null;

  return (
    <div className="bg-white shadow overflow-hidden rounded-lg px-4 py-5">
      <h2 className="font-bold">Bill to</h2>
      <p>{billToName}</p>
      <address className="not-italic">
        {billToEmail}
        {billToEmail && billingAddress && <br />}
        {billingAddress && <AddressLines address={billingAddress} />}
      </address>
    </div>
  );
}
